import {Component, OnInit} from '@angular/core';
import {AlertService, UserService, MouseflowService} from '../_services';
import {Location} from "@angular/common";
import {User} from '../_models';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './mouseflow.component.html',
})
export class MouseflowToggleComponent implements OnInit {

  constructor(
    private alertService: AlertService,
    private location: Location,
    private mouseflowService: MouseflowService,
    private userService: UserService
  ) { }

  ngOnInit() {
    if (this.mouseflowService.isEnabled()) {
      this.mouseflowService.disable()
      this.alertService.success('Mouseflow recording has been disabled.', true);
      this.location.back()
    } else {
      this.userService.getCurrent()
        .subscribe((user: User) => {
          this.mouseflowService.enable(user);
          this.alertService.success('Your session is being recorded in mouseflow now.', true);
          this.location.back()
        })
    }
  }

}
